module.exports = __webpack_public_path__ + "static/media/easy-exchange.c7f1b753.svg";